import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ActivityAction } from '@stores/activity/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';


interface ActivityListProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    activity?: ActivityAction;
}

interface ActivityListState {
    loading: boolean;
    error: any
    pageLoaded: any
    activityList: any
    navList: any
    navCurrentIndex: any
    navCurrentType: any
}
@inject('app', 'activity')
@observer
class ActivityList extends BasePage<ActivityListProps, ActivityListState> {
    namespace='activityList';
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        activityList: [],   // 活动列表
        navList: [
            {name: '全部', id: 0, type: '0'},
            {name: '线下', id: 1, type: '2'},
            {name: '线上', id: 2, type: '1'},
            {name: '我的收藏', id: 3, type: '3'},
        ],
        navCurrentIndex: 0, // 导航当前选中索引
        navCurrentType: '0'
    };
    componentDidMount() {
        // 初始化获取列表
        this.getActivityList()
       super.componentDidMount();
    }
    
    // 加载活动列表
    getActivityList = () => {
        const { activity } = this.props;
        let { navCurrentType } = this.state;
        if(activity) {
            // 如果是我的收藏（type为3），调用收藏列表接口
            if (navCurrentType === '3') {
                let params:any = {
                    "page[number]": 1,
                    "page[size]": 20,
                }
                activity.getActivityFavoriteList(params)
            } else {
                let params:any = {
                    "page[number]": 1,
                    "page[size]": 20,
                }
                
                if(navCurrentType) {
                    params['filter[type]'] = navCurrentType
                }
                activity.getActivityList(params)
            }
        }
    }

    // 只获取数据，不渲染
    getActivityListData = () => {
        const { activity } = this.props;
        const { navCurrentType } = this.state;
        if (!activity || !activity.listStore) return [];
        
        // 根据当前选中的标签类型决定使用哪个namespace
        const namespace = navCurrentType === '3' ? 'activityFavoriteList' : this.namespace;
        const list = activity.listStore.lists[namespace];
        if (!list) return [];
        return activity.listStore.getList({ namespace });
    }

    // 类型切换
    navClick = (item:any, index:any) => {
        this.setState({
            navCurrentIndex: index,
            navCurrentType: item.type
        }, () => {
            this.getActivityList()
        })
    }

    // 分页 - 加载更多
    handleLoadMore = () => {
        const { activity } = this.props;
        const { navCurrentType } = this.state;
        
        if (!activity) return;

        // 根据当前选中的标签类型决定使用哪个namespace
        const namespace = navCurrentType === '3' ? 'activityFavoriteList' : this.namespace;
        const list = activity.listStore.lists[namespace];
        
        if (!list) return;

        // 判断是否还有更多数据
        if (!list.hasMore) {
            return;
        }

        // 防止重复加载
        if (list.loading) {
            return;
        }

        // 获取当前页码
        const currentPage = list.attribs?.page || 1;
        const nextPage = currentPage + 1;

        // 如果是我的收藏（type为3），调用收藏列表接口
        if (navCurrentType === '3') {
            let params:any = {
                "page[number]": nextPage,
                "page[size]": 20,
            }
            activity.getActivityFavoriteList(params)
        } else {
            let params:any = {
                "page[number]": nextPage,
                "page[size]": 20,
            }
            
            if (navCurrentType) {
                params['filter[type]'] = navCurrentType
            }
            activity.getActivityList(params)
        }
    }

    render() {
        const { app, activity } = this.props;
        const { navList, navCurrentIndex } = this.state;
        const platform = app?.platform || 'h5';
         // 获取列表数据和状态
        const namespace = this.state.navCurrentType === '3' ? 'activityFavoriteList' : this.namespace;
        const listStore = activity?.listStore;
        const list = listStore?.lists[namespace];
        const activityList = listStore?.getList({ namespace }) || [];
        const loading = list?.loading || false;
        const hasMore = list?.hasMore ?? true;
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
           return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                    {...this.props}
                    activityList={activityList}
                    navList={navList}
                    navCurrentIndex={navCurrentIndex}
                    navClick={this.navClick}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={this.handleLoadMore}
                ></PC>) : (
                    <H5
                        {...this.props}
                        activityList={activityList}
                        navList={navList}
                        navClick={this.navClick}
                        navCurrentIndex={navCurrentIndex}
                        loading={loading}
                        hasMore={hasMore}
                        onLoadMore={this.handleLoadMore}
                    ></H5>
                )}
            </div>)
        }
        
    }
}

export default withRouter(ActivityList);